import './HeroSection.css';
import heroDashboard from '../assets/hero.png';
import underlineImg from '../assets/underline.png';
import { IconLightning, IconArrow, IconChart, IconTarget, IconHeadset } from './Icons';

const features = [
  { icon: <IconChart />, title: 'Data-Driven Growth', sub: 'Strategies that scale' },
  { icon: <IconTarget />, title: 'Conversion Focused', sub: 'More sales, higher ROI' },
  { icon: <IconHeadset />, title: 'Full Funnel Support', sub: 'From store to scale' },
];

const avatarColors = ['#4f46e5', '#7c3aed', '#2563eb', '#0891b2'];
const avatarInitials = ['A', 'S', 'M', 'R'];

export default function HeroSection() {
  return (
    <div className="hero-container">
      <div className="hero-left">

        <div className="badge">
          <span className="badge-icon"><IconLightning /></span>
          E-COMMERCE ACCELERATOR
        </div>

        <h1 className="hero-heading">Build. Scale. Dominate.</h1>

        <div className="hero-sub-wrapper">
          <span className="hero-sub">
            <span className="hero-sub-black">We Accelerate</span>
            <br />E-commerce Brands
          </span>
          <img src={underlineImg} alt="" className="hero-underline" />
        </div>

        <p className="hero-desc">
          End-to-end e-commerce &amp; web development solutions that fuel growth,
          boost conversions, and scale brands to 7-figures and beyond.
        </p>

        <div className="hero-features">
          {features.map((f) => (
            <div className="feature-item" key={f.title}>
              <span className="feature-icon">{f.icon}</span>
              <div>
                <div className="feature-title">{f.title}</div>
                <div className="feature-sub">{f.sub}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="hero-buttons">
          <a href="/about" className="btn-primary">
            Our Creative Work <IconArrow />
          </a>
          <a href="/blog" className="btn-outline">
            Read the Blog <IconArrow />
          </a>
        </div>

        <div className="hero-social-proof">
          <div className="avatar-stack">
            {avatarColors.map((color, i) => (
              <span
                key={i}
                className="avatar-circle"
                style={{ background: color, zIndex: avatarColors.length - i }}
              >
                {avatarInitials[i]}
              </span>
            ))}
          </div>
          <div className="social-proof-text">
            <span className="stars">★★★★★</span>
            <span className="social-proof-label">Trusted by 20+ e-commerce brands</span>
          </div>
        </div>

      </div>

      <div className="hero-right">
        <img
          src={heroDashboard}
          alt="E-commerce dashboard"
          className="dashboard-img"
        />
      </div>
    </div>
  );
}
